import {
  Acreditacion,
  Adeudo,
  Ayudante,
  Ayudantia,
  CuentaBancaria,
  ExcepcionInvestigador,
  HistoricoPagos,
  ParticipacionEvaluador,
  VigenciaSni,
} from '@conacyt/historicopersonasms-client';
import XLSX from 'xlsx';
import * as dateUtils from '@/shared/date/date-utils';

interface ConsultaHistoricoPagos extends HistoricoPagosExtend {
  expedienteInvestigador: string;
  mes: string;
  anio: string;
  nivel: string;
  ubicacion: string;
  sucursal: string;
  cuenta: string;
  monto: string;
  montoPagar: string;
  montoDeducciones: string;
  seguros: string;
  cuentaCLABE: string;
  cvuInvestigador: string;
  expedienteAyudante: string;
  cvuAyudante: string;
  origen: string;
  claveNomina: string;
  curp: string;
  estatusPago: string;
}

interface ConsultaHistoricoPagosExcel extends HistoricoPagosExtend {
  expedienteInvestigador: string;
  mes: string;
  anio: string;
  nivel: string;
  ubicacion: string;
  sucursal: string;
  cuenta: string;
  monto: number;
  montoPagar: number;
  montoDeducciones: string;
  seguros: number;
  cuentaCLABE: string;
  cvuInvestigador: string;
  expedienteAyudante: string;
  cvuAyudante: string;
  origen: string;
  claveNomina: string;
  curp: string;
  estatusPago: string;
}
interface HistoricoPagosExtend {
  montoPagado: string;
}

interface ConsultaHistoricoPagosExcelExpediente extends HistoricoPagosExtend {
  anio: string;
  nivel: string;
  ubicacion: string;
  sucursal: string;
  cuentaCLABE: string;
  mes: string;
  monto: number;
  montoPagar: number;
  montoDeducciones: string;
  estatusPago: string;
}
interface ConsultaHistoricoVigencias {
  solicitudId: string;
  nivelSni: string;
  tipo: string;
  convocatoria: string;
  fechaInicio: string;
  fechaFin: string;
  urlConvenio: string;
  urlReconocimiento: string;
}

interface ConsultaHistoricoCuentasBancarias {
  proceso: string;
  banco: string;
  numeroCuenta: string;
  estadoSolicitud: string;
  fechaModificacion: string;
}

interface ConsultaHistoricoAcreditaciones {
  tipo: string;
  tipificacion: string;
  tipoInstitucionDesc: string;
  tipoInstitucionNivelUNODesc: string;
  institucion: string;
  dependenciaDesc: string;
  subDependenciaDesc: string;
  departamentoDesc: string;
  tipoParticipacion: string;
  fechaInicio: string;
  fechaFin: string;
  estadoSolicitud: string;
  documento: string;
  fechaCreacion: string;
}
interface ConsultaHistoricoAdeudos {
  solicitudId: string;
  descripcion: string;
  anio: number;
  estatusInicial: string;
  fechaAlta: string;
  estatusFinal: string;
  fechaCierre: string;
}

interface ConsultaHistoricoExcepciones {
  solicitudId: string;
  descripcion: string;
  anio: number;
  estatusInicial: string;
  fechaAlta: string;
  estatusFinal: string;
  fechaCierre: string;
  urlComprobante: string;
}
interface ConsultaHistoricoParticipacionesComoEvaluador {
  nombre: string;
  fechaApertura: string;
}
interface ConsultaHistoricoAyudantias {
  fechaInicio: string;
  fechaFin: string;
  umas: number;
  cvuInvestigador: string;
  estadoSolicitud: string;
  urlConvenio: string;
}
interface ConsultaHistoricoMisAyudantes {
  fechaInicio: string;
  fechaFin: string;
  umas: number;
  estadoSolicitud: string;
  cvuAyudante: string;
  nombreCompletoAyudante: string;
  urlConvenio: string;
}

interface ReporteMovimientosNominaExcel {
  cvu: number;
  nombre: string;
  tipoReceptor: string;
  frecuencia: string;
  claveMovimiento: string;
  tipoMovimiento: string;
  categoria: string;
  detalle: string;
  documentacion: string;
  montoNoAplicado: string;
  montoAplicado: string;
  cvuInvestigador: number;
  nombreOperador: string;
}
export default class Utilidades {
  public regExpNumero = /^\d+$/;
  public regExpClavePrograma = /^\d{6}$/;
  public regExpPorcentaje = /^(100(\.00?)?|[1-9]\d?(\.\d{0,2})?)$/;
  public regExpMonto = /^(?!0\d{6,})([1-9]\d{0,6}|0)(\.\d{0,2})?$/;
  public regExpDivisa = /^\d{1,3}(\.\d{0,4})?$/;
  public regExpMontoNegativo = /^-?(?!0\d{6,})([1-9]\d{0,6}|0)(\.\d{0,2})?$/;

  public bancos: { [clave: string]: string } = {
    '002': 'BANAMEX',
    '006': 'BANCOMEXT',
    '009': 'BANOBRAS',
    '012': 'BBVA BANCOMER',
    '014': 'SANTANDER',
    '019': 'BANJERCITO',
    '021': 'HSBC',
    '030': 'BAJIO',
    '032': 'IXE',
    '036': 'INBURSA',
    '037': 'INTERACCIONES',
    '042': 'MIFEL',
    '044': 'SCOTIABANK',
    '058': 'BANREGIO',
    '059': 'INVEX',
    '060': 'BANSI',
    '062': 'AFIRME',
    '072': 'BANORTE',
    '102': 'THE ROYAL BANK',
    '103': 'AMERICAN EXPRESS',
    '106': 'BAMSA',
    '108': 'TOKYO',
    '110': 'JP MORGAN',
    '112': 'BMONEX',
    '113': 'VE POR MAS',
    '116': 'ING',
    '124': 'DEUTSCHE',
    '126': 'CREDIT SUISSE',
    '127': 'AZTECA',
    '128': 'AUTOFIN',
    '129': 'BARCLAYS',
    '130': 'COMPARTAMOS',
    '131': 'BANCO FAMSA',
    '132': 'BMULTIVA',
    '133': 'ACTINVER',
    '134': 'WAL-MART',
    '135': 'NAFIN',
    '136': 'INTERBANCO',
    '137': 'BANCOPPEL',
    '138': 'ABC CAPITAL',
    '139': 'UBS BANK',
    '140': 'CONSUBANCO',
    '141': 'VOLKSWAGEN',
    '143': 'CIBANCO',
    '145': 'BBASE',
    '166': 'BANSEFI',
    '168': 'HIPOTECARIA FEDERAL',
    '600': 'MONEXCB',
    '601': 'GBM',
    '602': 'MASARI',
    '605': 'VALUE',
    '606': 'ESTRUCTURADORES',
    '607': 'TIBER',
    '608': 'VECTOR',
    '610': 'B&B',
    '614': 'ACCIVAL',
    '615': 'MERRILL LYNCH',
    '616': 'FINAMEX',
    '617': 'VALMEX',
    '618': 'UNICA',
    '619': 'MAPFRE',
    '620': 'PROFUTURO',
    '621': 'CB ACTINVER',
    '622': 'OACTIN',
    '623': 'SKANDIA',
    '626': 'CBDEUTSCHE',
    '627': 'ZURICH',
    '628': 'ZURICHVI',
    '629': 'SU CASITA',
    '630': 'CB INTERCAM',
    '631': 'CI BOLSA',
    '632': 'BULLTICK CB',
    '633': 'STERLING',
    '634': 'FINCOMUN',
    '636': 'HDI SEGUROS',
    '637': 'ORDER',
    '638': 'AKALA',
    '640': 'CB JPMORGAN',
    '642': 'REFORMA',
    '646': 'STP',
    '647': 'TELECOMM',
    '648': 'EVERCORE',
    '649': 'SKANDIA',
    '651': 'SEGMTY',
    '652': 'ASEA',
    '653': 'KUSPIT',
    '655': 'SOFIEXPRESS',
    '656': 'UNAGRA',
    '659': 'OPCIONES EMPRESARIALES DEL NOROESTE',
    '670': 'LIBERTAD',
    '901': 'CLS',
    '902': 'INDEVAL',
    '999': 'N/A',
  };

  /**
   * Método para construir la consulta con la información del histórico de pagos.
   */
  public construirHistoricoPagos(historicoPagos: HistoricoPagos): ConsultaHistoricoPagos {
    return {
      cvuInvestigador: historicoPagos?.cvuInvestigador,
      cvuAyudante: historicoPagos?.cvuAyudante,
      mes: historicoPagos?.nivel ? this.convertirFormatoMes(historicoPagos?.mes) : '',
      anio: historicoPagos?.anio,
      nivel: historicoPagos?.nivel ? this.convertirFormatoNivelSni(historicoPagos?.nivel) : '',
      ubicacion: historicoPagos?.ubicacion,
      sucursal: historicoPagos?.sucursal,
      cuenta: historicoPagos?.cuenta,
      cuentaCLABE: historicoPagos?.cuentaCLABE,
      monto: historicoPagos?.monto ? this.formatearMonto(historicoPagos?.monto) : '',
      montoPagar: historicoPagos?.montoPagar ? this.formatearMonto(historicoPagos?.montoPagar) : '',
      montoPagado: this.getMontoPagado(historicoPagos),
      montoDeducciones: historicoPagos?.montoDeducciones ? this.formatearMonto(-Math.abs(historicoPagos?.montoDeducciones)) : '',
      seguros: historicoPagos?.seguros ? this.formatearMonto(historicoPagos?.seguros) : '',
      claveNomina: historicoPagos?.claveNomina,
      curp: historicoPagos?.curp,
      origen: historicoPagos?.origen,
      expedienteInvestigador: historicoPagos?.expedienteInvestigador,
      expedienteAyudante: historicoPagos?.expedienteAyudante,
      estatusPago: historicoPagos?.estatusPago,
    };
  }

  /**
   * Método para construir la consulta para el excel con la información del histórico de pagos.
   */
  public construirHistoricoPagosExcel(historicoPagos: HistoricoPagos): ConsultaHistoricoPagosExcel {
    return {
      cvuInvestigador: historicoPagos?.cvuInvestigador,
      cvuAyudante: historicoPagos?.cvuAyudante,
      mes: historicoPagos?.mes,
      anio: historicoPagos?.anio,
      nivel: historicoPagos?.nivel ? this.convertirFormatoNivelSni(historicoPagos?.nivel) : '',
      ubicacion: historicoPagos?.ubicacion,
      sucursal: historicoPagos?.sucursal,
      cuenta: historicoPagos?.cuenta,
      cuentaCLABE: historicoPagos?.cuentaCLABE,
      monto: historicoPagos?.monto,
      montoPagar: historicoPagos?.montoPagar,
      montoPagado: this.getMontoPagado(historicoPagos),
      montoDeducciones: historicoPagos?.montoDeducciones ? this.formatearMonto(-Math.abs(historicoPagos?.montoDeducciones)) : '',
      seguros: historicoPagos?.seguros,
      claveNomina: historicoPagos?.claveNomina,
      curp: historicoPagos?.curp,
      origen: historicoPagos?.origen,
      expedienteInvestigador: historicoPagos?.expedienteInvestigador,
      expedienteAyudante: historicoPagos?.expedienteAyudante,
      estatusPago: historicoPagos?.estatusPago,
    };
  }

  /**
   * Método para construir el reporte de movimientos Nomina.
   */
  public construirReporteMovimientosExcel(movimientos: any): ReporteMovimientosNominaExcel {
    const formatearMonto = (monto: number) => {
      return new Intl.NumberFormat('es-MX', {
        style: 'currency',
        currency: 'MXN',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(monto);
    };

    return {
      cvu: movimientos.pago.persona.cvu ? movimientos.pago.persona.cvu : '',
      nombre: movimientos.pago.persona.nombre_completo
        ? movimientos.pago.persona.nombre_completo
        : `${movimientos.pago.persona.nombre || ''} ${movimientos.pago.persona.apellido_paterno || ''} ${
            movimientos.pago.persona.apellido_materno || ''
          }`.trim(),

      tipoReceptor: movimientos.pago.tipoReceptor ?? '',
      frecuencia: movimientos.movimientoPago.frecuenciaMovimientoPago ?? '',
      claveMovimiento: movimientos.movimientoPago.clave ?? '',
      tipoMovimiento: movimientos.movimientoPago.descripcionTipo ?? '',
      categoria: movimientos.movimientoPago.descripcionCategoria ?? '',
      detalle: movimientos.detalle ?? '',
      documentacion: movimientos.movimientoPago.documentacionCompleta ? 'Completa' : '',
      montoNoAplicado: movimientos.montoNoAplicado !== undefined ? formatearMonto(movimientos.montoNoAplicado) : '$0.00',
      montoAplicado:
        movimientos.pago.tipoReceptor === 'PENSIONISTA'
          ? formatearMonto(movimientos.montoAplicado)
          : movimientos.movimientoPago.claveTipo === 'D' && movimientos.montoAplicado !== 0
          ? `-${formatearMonto(Math.abs(movimientos.montoAplicado))}`
          : formatearMonto(movimientos.montoAplicado),
      cvuInvestigador: movimientos.pago.receptor.cvuInvestigador ?? '',
      nombreOperador: movimientos.movimientoPago.nombreOperador ?? '',
    };
  }

  /**
   * Método para construir la consulta para el excel con la información del histórico de pagos.
   */
  public construirHistoricoPagosExcelBuscadorExpediente(historicoPagos: HistoricoPagos): ConsultaHistoricoPagosExcelExpediente {
    return {
      anio: historicoPagos?.anio,
      nivel: historicoPagos?.nivel ? this.convertirFormatoNivelSni(historicoPagos?.nivel) : '',
      ubicacion: historicoPagos?.ubicacion,
      sucursal: historicoPagos?.sucursal,
      cuentaCLABE: historicoPagos?.cuentaCLABE,
      mes: historicoPagos?.nivel ? this.convertirFormatoMes(historicoPagos?.mes) : '',
      monto: historicoPagos?.monto,
      montoPagar: historicoPagos?.montoPagar,
      montoPagado: this.getMontoPagado(historicoPagos),
      montoDeducciones: historicoPagos?.montoDeducciones ? this.formatearMonto(-Math.abs(historicoPagos?.montoDeducciones)) : '',
      estatusPago: historicoPagos?.estatusPago,
    };
  }

  /**
   * Método para construir montoPagado de historico pago.
   */
  public getMontoPagado(historicoPagos: HistoricoPagos): string {
    return historicoPagos?.estatusPago === 'RECHAZADO' ? this.formatearMonto(0) : this.formatearMonto(historicoPagos?.montoPagar);
  }

  /**
   * Método para construir la consulta para el excel con la información de vigencias
   */
  public construirHistoricoVigencias(vigenciaSni: VigenciaSni): any {
    const inicio = vigenciaSni?.vigencia?.fechaInicio ? vigenciaSni.vigencia.fechaInicio.substring(0, 10) : '';

    const fin = vigenciaSni?.vigencia?.fechaFin ? vigenciaSni.vigencia.fechaFin.substring(0, 10) : '';
    return {
      'Tipo de Vigencia': vigenciaSni?.tipo?.descripcion,
      'Nivel Snii': vigenciaSni?.nivelSni?.descripcion,
      'Inicio de Vigencia': inicio ? dateUtils.defaultFormat(inicio) : '',
      'Fin de Vigencia': fin ? dateUtils.defaultFormat(fin) : '',
      'Estado de Vigencia': vigenciaSni?.estatusVigencia?.descripcion,
      'Url Convenio': vigenciaSni?.urlConvenio,
      'Url Reconocimiento': vigenciaSni?.urlReconocimiento,
    };
  }

  /**
   * Método para construir la consulta para el excel con la información de cuentas bancarias
   */
  public construirHistoricoCuentasBancarias(cuentasBancarias: CuentaBancaria): any {
    const registro: any = {
      Proceso: cuentasBancarias?.proceso,
      Banco: cuentasBancarias?.banco,
      'Cuenta Clabe': cuentasBancarias?.numeroCuenta,
      Estado: cuentasBancarias?.estadoSolicitud,
      'Fecha Modificación': cuentasBancarias?.fechaModificacion
        ? new Date(cuentasBancarias.fechaModificacion).toISOString().replace('Z', '+00:00')
        : '',
    };
    if (cuentasBancarias?.urlComprobante) {
      registro['Url Comporbante'] = cuentasBancarias.urlComprobante;
    }
    return registro;
  }

  /**
   * Método para construir la consulta para el excel con la información de Acreditaciones
   */
  public construirHistoricoAcreditaciones(acreditaciones: Acreditacion): any {
    const comprobante = acreditaciones?.documento?.idContentManagment;

    const comprobanteFinal = comprobante
      ? comprobante.startsWith('http')
        ? comprobante
        : `https://miic.conacyt.mx/generador-api/getPdf?idDocumentoCMS=${comprobante}`
      : '';
    return {
      Situación: acreditaciones?.tipo?.descripcion,
      'Tipo de Programa': acreditaciones?.proceso,
      'Tipo de Institución': acreditaciones?.institucion?.tipoInstitucionDesc,
      Institución: acreditaciones?.institucion?.descripcion,
      Dependencia: acreditaciones?.institucion?.dependenciaDesc,
      Subdependencia: acreditaciones?.institucion?.subDependenciaDesc,
      Departamento: acreditaciones?.institucion?.departamentoDesc,
      'Tipo de Participación': acreditaciones?.tipoParticipacion,
      'Fecha Inicio': acreditaciones?.vigencia?.fechaInicio ? dateUtils.defaultFormat(acreditaciones.vigencia.fechaInicio) : '',
      'Fecha Fin': acreditaciones?.vigencia?.fechaFin ? dateUtils.defaultFormat(acreditaciones.vigencia.fechaFin) : '',
      'Estado de la Solicitud': acreditaciones?.estadoSolicitud,
      Comprobante: comprobanteFinal,
      'Fecha de Firma de Informe': acreditaciones?.informe?.fechaCreacion
        ? dateUtils.defaultFormat(acreditaciones.informe.fechaCreacion)
        : '',
    };
  }

  /**
   * Método para construir la consulta para el excel con la información de Excepciones
   */
  public construirHistoricoExcepciones(excepcionInvestigador: ExcepcionInvestigador): ConsultaHistoricoExcepciones {
    return {
      solicitudId: excepcionInvestigador?.solicitudId,
      descripcion: excepcionInvestigador?.tipo.descripcion,
      anio: excepcionInvestigador?.anio,
      estatusInicial: excepcionInvestigador?.estatusInicial,
      estatusFinal: excepcionInvestigador?.estatusFinal,
      fechaAlta: excepcionInvestigador?.fechaAlta ? dateUtils.defaultFormat(excepcionInvestigador.fechaAlta) : '',
      urlComprobante: excepcionInvestigador?.urlComprobante,
      fechaCierre: excepcionInvestigador?.fechaCierre ? dateUtils.defaultFormat(excepcionInvestigador.fechaCierre) : '',
    };
  }

  /**
   * Método para construir la consulta para el excel con la información de Adeudos
   */
  public construirHistoricoAdeudos(adeudo: Adeudo): ConsultaHistoricoAdeudos {
    return {
      solicitudId: adeudo?.solicitudId,
      descripcion: adeudo?.tipo.descripcion,
      anio: adeudo?.anio,
      estatusInicial: adeudo?.estatusInicial,
      fechaAlta: adeudo?.fechaAlta ? dateUtils.defaultFormat(adeudo.fechaAlta) : '',
      estatusFinal: adeudo?.estatusFinal,
      fechaCierre: adeudo?.fechaCierre ? dateUtils.defaultFormat(adeudo.fechaCierre) : '',
    };
  }
  /**
   * Método para construir la consulta para el excel con la información de Participaciones Como Evaluador
   */
  public construirHistoricoParticipacionesComoEvaluado(
    participacionEvaluador: ParticipacionEvaluador
  ): ConsultaHistoricoParticipacionesComoEvaluador {
    return {
      nombre: participacionEvaluador?.convocatoria?.nombre,
      fechaApertura: participacionEvaluador?.convocatoria?.fechaApertura
        ? dateUtils.defaultFormat(participacionEvaluador?.convocatoria?.fechaApertura)
        : '',
    };
  }
  /**
   * Método para construir la consulta para el excel con la información de Participaciones Como Ayudantias
   */
  public construirHistoricoAyudantias(ayudantias: Ayudantia): ConsultaHistoricoAyudantias {
    return {
      fechaInicio: ayudantias.vigencia.fechaInicio ? dateUtils.defaultFormat(ayudantias?.vigencia?.fechaInicio) : '',
      fechaFin: ayudantias.vigencia.fechaFin ? dateUtils.defaultFormat(ayudantias?.vigencia?.fechaFin) : '',
      umas: ayudantias?.umas,
      cvuInvestigador: ayudantias?.cvuInvestigador,
      estadoSolicitud: ayudantias?.estadoSolicitud,
      urlConvenio: ayudantias.convenio.urlConvenio,
    };
  }
  /**
   * Método para construir la consulta para el excel con la información de Participaciones Como Mis Ayudante
   */
  public construirHistoricoMisAyudantes(ayudante: Ayudante): ConsultaHistoricoMisAyudantes {
    return {
      fechaInicio: ayudante?.ayudantia.vigencia?.fechaInicio ? dateUtils.defaultFormat(ayudante?.ayudantia.vigencia?.fechaInicio) : '',
      fechaFin: ayudante?.ayudantia.vigencia?.fechaFin ? dateUtils.defaultFormat(ayudante?.ayudantia.vigencia?.fechaFin) : '',
      umas: ayudante?.ayudantia.umas,
      estadoSolicitud: ayudante?.ayudantia.estadoSolicitud,
      cvuAyudante: ayudante?.persona?.cvu,
      nombreCompletoAyudante: `${ayudante?.persona?.nombre ?? ''} ${ayudante?.persona?.apellidoPaterno ?? ''} ${
        ayudante?.persona?.apellidoMaterno ?? ''
      }`.trim(),
      urlConvenio: ayudante?.ayudantia.convenio?.urlConvenio,
    };
  }

  /**
   * Método para dar formato de moneda a una cantidad númerica.
   */
  public formatearMonto(monto: number): string {
    return monto
      ? monto.toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })
      : (0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' });
  }

  /**
   * Método para dar formato de porcentaje a una cantidad númerica.
   */
  public formatearPorcentaje(valor: string): string {
    return !isNaN(Number(valor)) ? `${valor}%` : `${0}%`;
  }

  /**
   * Método para convertir una clave de nivelSni a su descripción.
   */
  public convertirFormatoNivelSni(claveNivelSni: string): string {
    switch (claveNivelSni) {
      case 'C':
      case 'C1':
      case 'C2':
        return 'CANDIDATO';
      case '1':
        return 'NIVEL I';
      case '2':
        return 'NIVEL II';
      case '3':
        return 'NIVEL III';
      case 'E':
        return 'EMÉRITO';
      case 'A':
        return 'AYUDANTE';
      case 'B':
        return 'BENEFICIARIO';
      case 'P':
        return 'PENSIONISTA';
      default:
        return claveNivelSni;
    }
  }

  /**
   * Método para convertir el mes .
   */
  public convertirFormatoMes(numeroMes: string): string {
    switch (numeroMes) {
      case '1':
        return 'ENERO';
      case '2':
        return 'FEBRERO';
      case '3':
        return 'MARZO';
      case '4':
        return 'ABRIL';
      case '5':
        return 'MAYO';
      case '6':
        return 'JUNIO';
      case '7':
        return 'JULIO';
      case '8':
        return 'AGOSTO';
      case '9':
        return 'SEPTIEMBRE';
      case '10':
        return 'OCTUBRE';
      case '11':
        return 'NOVIEMBRE';
      case '12':
        return 'DICIEMBRE';

      default:
        return numeroMes;
    }
  }

  /**
   * Método para filtrar las pulsaciones del teclado por expresión regular.
   */
  public filtrarPorExpresionRegular(event: KeyboardEvent, regex: RegExp): void {
    const key = event.key;
    const tempValue = (event.target as HTMLInputElement).value == null ? key : (event.target as HTMLInputElement).value + key;
    const isNumber = regex.test(tempValue);
    const isSpecial = ['Backspace', 'Enter', 'Delete'].includes(key);
    if (!isNumber && !isSpecial) {
      event.preventDefault();
    }
  }

  /**
   * Método para exportar en excel y si está definido columnasAFormatear,
   * formatea las columnas seleccionadas en formato moneda.
   */
  public exportarExcel(filas, nombre, columnasAFormatear = null) {
    const workbook = XLSX.utils.book_new();
    const sheet = XLSX.utils.json_to_sheet(filas);

    if (columnasAFormatear != null) {
      const range = XLSX.utils.decode_range(sheet['!ref']);
      for (let i = range.s.r + 1; i <= range.e.r; i++) {
        columnasAFormatear.forEach(nombreColumna => {
          const indiceColumna = Object.keys(filas[0]).indexOf(nombreColumna);
          const cellRef = XLSX.utils.encode_cell({ c: indiceColumna, r: i });
          sheet[cellRef].z = '"$"#,##0.00_);\\("$"#,##0.00\\)';
        });
      }
    }

    XLSX.utils.book_append_sheet(workbook, sheet, nombre);
    const blob = new Blob([XLSX.write(workbook, { bookType: 'xlsx', type: 'array' })], { type: 'application/octet-stream' });
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = `${this.obtenerFechaNombre() + '-' + nombre}.xlsx`;
    link.click();
  }

  /**
   * Método para obtener la fecha actual como nombre.
   */
  public obtenerFechaNombre() {
    const currentDate = new Date();
    return (
      currentDate.getFullYear() +
      '' +
      currentDate.getMonth() +
      '' +
      currentDate.getHours() +
      '' +
      currentDate.getMinutes() +
      '' +
      currentDate.getSeconds()
    );
  }

  /**
   * Método para obtener la edad a partir de una fecha de tipo string.
   */
  public calcularEdad(fechaNacimiento: string): number {
    const fechaNacimientoDate = new Date(fechaNacimiento);
    const hoy = new Date();
    let edad = hoy.getFullYear() - fechaNacimientoDate.getFullYear();
    const mesActual = hoy.getMonth();
    const diaActual = hoy.getDate();
    const mesNacimiento = fechaNacimientoDate.getMonth();
    const diaNacimiento = fechaNacimientoDate.getDate();

    if (mesActual < mesNacimiento || (mesActual === mesNacimiento && diaActual < diaNacimiento)) {
      edad--;
    }
    return edad;
  }

  public calcularEdadConFecha(fechaNacimiento: Date): number {
    const hoy = new Date();
    let edad = hoy.getFullYear() - fechaNacimiento.getFullYear();
    const mesActual = hoy.getMonth();
    const diaActual = hoy.getDate();
    const mesNacimiento = fechaNacimiento.getMonth();
    const diaNacimiento = fechaNacimiento.getDate();

    if (mesActual < mesNacimiento || (mesActual === mesNacimiento && diaActual < diaNacimiento)) {
      edad--;
    }
    return edad;
  }

  public calcularTotalPaginas(totalItems: number, pageSize: number): number {
    return Math.ceil(totalItems / pageSize);
  }

  /**
   * Método para dar el formato: 99,999.
   *
   * @param value valor a dar formato.
   * @returns valor con formato.
   */
  public formatearConComasSinDecimales(value): string {
    return value
      ? value.toLocaleString('es-MX', {
          maximumFractionDigits: 0,
        })
      : (0).toLocaleString('es-MX', {
          maximumFractionDigits: 0,
        });
  }

  /**
   * Método para obtener el nombre del banco a partir de
   * la clabe bancaria, en caso de no encontrarlo regresa
   * cadena vacía.
   *
   * @param cuentaClabe clabeBancaria.
   * @returns valor con el nombre del banco o cadena vacía.
   */
  public obtenerBanco(cuentaClabe: string): string {
    let nombreBanco = '';

    if (cuentaClabe?.length >= 3) {
      const numeroBanco = cuentaClabe.substring(0, 3);
      nombreBanco = this.bancos[numeroBanco] || '';
    }

    return nombreBanco;
  }

  public obtenerPeriodoFormateado(fechaInicio, fechaFin): string {
    return fechaInicio + ' - ' + fechaFin;
  }

  public filtrarExpresionRegularMontos(event: KeyboardEvent, regex: RegExp): void {
    const key = event.key;

    const isSpecial = ['Backspace', 'Enter', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'].includes(key);
    if (isSpecial) return;

    const input = event.target as HTMLInputElement;
    const selectionStart = input.selectionStart || 0;
    const selectionEnd = input.selectionEnd || 0;

    const newValue = input.value.substring(0, selectionStart) + key + input.value.substring(selectionEnd);

    // Permitir temporalmente signos válidos en construcción
    const valoresTemporalesPermitidos = ['-', '-.', '-0', '-0.', ''];
    if (valoresTemporalesPermitidos.includes(newValue)) return;

    if (!regex.test(newValue)) {
      event.preventDefault();
    }
  }
}
